import angular from 'angular';

angular.module('cloudX').directive('cxSalutationSelect', [
  function() {
    return {
      restrict: 'E',
      template:
        '<a href="#" editable-select="salutation" onbeforesave="save({newValue:$data})" e-ng-options="(salutation | translateList:\'salutation\') ' +
        'for salutation in salutations" e-ng-change="choosing()">' +
        '<span ng-show="salutation">{{salutation | translateList:\'salutation\'}}</span><i class="glyphicon glyphicon-pencil" ng-show="!salutation"></i></a>',
      scope: {
        salutation: '=data',
        save: '&',
      },
      controller: [
        '$scope',
        'optionsSvc',
        function($scope, optionsSvc) {
          var chosen = false;
          if ($scope.salutation || $scope.salutation === 0) {
            chosen = true;
            $scope.salutations = optionsSvc.getOptionsWithDefault('salutation');
          } else $scope.salutations = optionsSvc.getOptionsWithDefault('salutation');
          $scope.choosing = function() {
            if (!chosen) {
              chosen = true;
              $scope.salutations = optionsSvc.getOptionsWithDefault('salutation');
            }
          };
        },
      ],
    };
  },
]);
